
import $ from "jquery"
import { EventEmitter } from "events"

/*
  Toggle Display
  Put the data attributes on a button or link

  Required attributes:
  data-js-app-toggle-to: string or missing value for no mode
  data-js-app-toggle-target: selector of target element (Maybe can be self?)

  Optional attibutes:
  data-js-mark-active-button: mark the button being clicked active, with given class
*/

const MODE_DATA_SELECTOR = "js-app-toggle-to"
const TARGET_DATA_SELECTOR = "js-app-toggle-target"
const MARK_ACTIVE_CLASS_DATA_SELECTOR = "js-mark-active-button"
const TOGGLE_SELECTOR = `[data-${MODE_DATA_SELECTOR}][data-${TARGET_DATA_SELECTOR}]`
const MODE_PREFIX = "with-mode-"

class SwitchMode extends EventEmitter {
  constructor() { super() }

  public onLoad(){
    $("body").on("click", TOGGLE_SELECTOR, (e) =>{
      e.preventDefault()
      const $this = $(e.target)
      const targetSelector = $this.data(TARGET_DATA_SELECTOR)
      const $targets = $(targetSelector)

      const new_mode = $this.data(MODE_DATA_SELECTOR)
      const mark_active_class = $this.data(MARK_ACTIVE_CLASS_DATA_SELECTOR)

      $targets.each((idx, el) => {
        const $target = $(el)
        // Remove all modes
        const class_names = $target.attr("class").split(/\s+/)
        class_names.forEach((class_name) => {
          if (class_name.match(new RegExp(`^${MODE_PREFIX}`))){
            $target.removeClass(class_name)
          }
        })
        // Add mode if present
        if (typeof new_mode === "string"){
          const new_mode_class = `${MODE_PREFIX}${new_mode}`
          $target.addClass(new_mode_class)
        }
      })

      $(`.${mark_active_class}`).removeClass(mark_active_class)
      if (typeof mark_active_class === "string"){
        $this.addClass(mark_active_class)
      }

      this.emit("switch_mode:mode_switched", [$this, $targets, new_mode])
    })
  }
}


export default new SwitchMode()
